import {colors} from "@c10h/colors";
import {useTranslation} from "ni18n";
import React from "react";

import {Btn, ImgWithBg} from "../V5Comp";

type Props = {
  bookingUrl: string;
  bookingBtnHandler: () => void;
  nextApptSlot: string;
};

const Hero: React.FC<Props> = ({bookingUrl, bookingBtnHandler, nextApptSlot}) => {
  const i18n = useTranslation();

  const gradient = {background: `linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 100%`};

  return (
    <ImgWithBg bgImage="/covid-positive-enrollment" className="">
      <div className="pos-r pt40 pt30-xs pb40 pb0-sm" style={gradient}>
        <div className="pv20 pb8-sm ma w100p maxw80 ph10 ph4-sm">
          <div className="fs48 fs38-md fs32-xs white font-csb lh12 mt20 maxw32 maxw28-md maxw16-xs">
            {i18n.t("I tested positive for COVID-19. Now what?")}
          </div>
          <p className="m0 mb14 mb0-sm lh12 white font-cm fs22 fs18-md fs16-sm maxw30 maxw24-md maxw22-sm maxw16-xs">
            {i18n.t(
              "Get relief, comfort, and expert COVID-19 care from the comfort of your home today.",
            )}
          </p>
          <div className="mt6 dgc aic gg4 jcs gtcn-sm mt16-sm">
            <Btn fontSize={1} bg={colors.gray800} href={bookingUrl} onClick={bookingBtnHandler}>
              {i18n.t("Talk to a Virtual Provider")}
            </Btn>
            <div className="gray50">
              {nextApptSlot && (
                <div className="fs18 fs16-sm font-csb font-ib-sm">{nextApptSlot}</div>
              )}
              <div className="mt2 fs14 fs12-sm font-ir">{i18n.t("$0 to enroll")}</div>
            </div>
          </div>
          <a className="df aic pos-a gray50 fs12 dn-sm" style={{bottom: 20}} href="#how">
            <span className="cIcon-arrow-down-thick mr2" />
            <span className="font-ib">{i18n.t("Learn More")}</span>
          </a>
        </div>
      </div>
    </ImgWithBg>
  );
};

export default Hero;
